import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import Crunch42CredentialsForm from "./Crunch42CredentialsForm";
import Crunch42ConfigListing from "./Crunch42ConfigListing";

export default function Crunch42PullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={Crunch42CredentialsForm}
      PullConfigListingView={Crunch42ConfigListing}
    />
  );
}
